@if (!editingThemeType) {
  <app-card preCardTitle="Map Themes">
    <form [formGroup]="formGroup">
      <div *appCardContent class="mb-8">
        @if (trackDurationHoursOptions) {
          <app-row-with-select primaryText="Track Duration"
                               secondaryText="How long a GPS track will stay on the map"
                               [list]="trackDurationHoursOptions"
                               listLabel="name"
                               listId="id"
                               formControlName="trackDurationHours">
          </app-row-with-select>
        }
      </div>
    </form>
    <div *appCardContentRaw>
      <mat-nav-list class="raw-card-list">
        <a mat-list-item
           (click)="onEditClick(MapThemeType.CURRENCY)"
        >
          <div matListItemTitle>Time Map</div>
          <div matListItemMeta style="align-self: center">
            <mat-icon>arrow_right</mat-icon>
          </div>
        </a>
        <a mat-list-item
           (click)="onEditClick(MapThemeType.COVERAGE)"
        >
          <div matListItemTitle>Pass Count Map</div>
          <div matListItemMeta style="align-self: center">
            <mat-icon>arrow_right</mat-icon>
          </div>
        </a>
        <a mat-list-item
           (click)="onEditClick(MapThemeType.GPS_TRACKS)"
        >
          <div matListItemTitle>GPS Tracks</div>
          <div matListItemMeta style="align-self: center">
            <mat-icon>arrow_right</mat-icon>
          </div>
        </a>
        <a mat-list-item
           (click)="onEditClick(MapThemeType.ROUTE_STATUS)"
        >
          <div matListItemTitle>Route Status</div>
          <div matListItemMeta style="align-self: center">
            <mat-icon>arrow_right</mat-icon>
          </div>
        </a>
      </mat-nav-list>
    </div>
    <div *appCardContentRaw class="my-8 px-16">
      <div class="flex-row justify-content-space-between align-items-center">
        <div>
          <div>
            Clear Map
          </div>
          <div>
            Reset all GPS tracks and map themes
          </div>
        </div>

        <button
          mat-stroked-button
          (click)="clearMapContent()"
        >
          Clear Map
        </button>
      </div>

      @if (configuration && configuration.contentVisibilityCutoff) {
        <div class="flex-row justify-content-space-between align-items-center indent">
          <div>
            Map Cleared at {{ configuration.contentVisibilityCutoff | date:'short' }}
          </div>

          <button
            mat-icon-button
            (click)="removeMapContentRestriction()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>
  </app-card>
} @else if (themeStyle) {
  <app-card
    [inCardTitle]="getCardTitle()"
    icon="arrow_back"
    actionIcon="sync"
    action2Icon="save"
    [iconDisabled]="false"
    (iconClicked)="backToList()"
    [iconTooltip]="'Back'"
    (actionIconClicked)="buttonClickedReset()"
    [actionIconDisabled]="false"
    [actionTooltip]="'Reset to default'"
    (action2IconClicked)="buttonClickedSave()"
    [action2IconDisabled]="!isButtonVisibleSave()"
    [action2Tooltip]="'Save'"
  >
    <div *appCardContent>
      <app-map-theme-editor
        [layerType]="themeStyle"
        (colorsChangedEvent)="themeStyleChanged($event)"
      ></app-map-theme-editor>
    </div>
  </app-card>
}
